module.exports = __webpack_public_path__ + "static/media/03.d2494625.jpeg";